<template>
  <base-section
  id="submissions"
  >
    <v-container>
    <base-section-heading
    title="Submissions"
    color="secondary"
    align="left"
    :toColor="true"
    >
To encourage and facilitate discussions, participation will be limited. Those interested in
presenting recent results at the symposium are invited to submit an extended abstract (one
to three pages) or a full paper (six pages). PDF electronic submissions must be done via the submission webpage in this <a href="https://easychair.org/conferences/?conf=lats2025">link</a>.
<br /> <br />
<v-btn
  href="https://easychair.org/conferences/?conf=lats2025"
  target="_blank"
  rounded
  color="primary"
  dark
  download
  style="padding: 15px"
>
  <v-icon
    left
    dark
  >
    mdi-open-in-new
  </v-icon>
  Link to the Sumissions website
</v-btn>
<br>
<br>
Authors should send papers in the IEEE conference format. The Program Committee also welcomes poroposals
for panels and special sessions. <br /> <br />
<strong>For additional information, please contact our Program Co-Chairs: <br /></strong>
Leticia Bolzani Poehls - RWTH Aachen, Germany - leticia@poehls.com <br />
Tiago Balen - UFRGS, Brazil - tiago.balen@ufrgs.br <br />
    </base-section-heading>
    <base-section-heading
    title="Key Dates"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>
Submission Deadline (Title and Abstract): <span style="color: #808080"><s>October 30th, 2024</s></span> <span style="color: #d7422b"><strong>November 8th, 2024 <span style="color: red;">(Extended Deadline)</span></strong></span> <br />
Submission Deadline (Full Paper): <span style="color: #808080"><s>November 15th, 2024</s></span> <span style="color: #d7422b"><strong>November 29th, 2024 <span style="color: red;">(Extended Deadline)</span></strong></span><br />
Notification of Acceptance: <span style="color: #d7422b"> <strong>December 6th, 2024</strong></span><br />
Camera Ready: <span style="color: #d7422b"><strong>December 20th, 2024</strong></span><br />
<!---Advance registration and hotel booking: <span style="color: #d7422b"><strong>February 6th, 2024</strong></span><br />--->
<br>
</strong>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Submissions',

    data: () => ({

    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
</style>
